/* eslint-disable */
// @ts-nocheck
// biome-ignore-all lint: auto-generated file

// This file is auto-generated by the flowbite-react CLI.
// Do not edit this file directly.
// Instead, edit the .flowbite-react/config.json file.

import { StoreInit } from "flowbite-react/store/init";
import React from "react";

export const CONFIG = {
  dark: false,
  prefix: "",
  version: 3,
};

export function ThemeInit() {
  return <StoreInit {...CONFIG} />;
}

ThemeInit.displayName = "ThemeInit";